export const getSavedState = (key, fallback = null) => {
    try {
        return JSON.parse(window.localStorage.getItem(key)) || fallback;
    } catch(e) {
        return fallback
    }
}

export const saveState = (key, state) => {
    window.localStorage.setItem(key, JSON.stringify(state))
}

export const isUUID = uuid =>  {
    let s = "" + uuid;

    s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
    return s !== null;
}

export const isSerialInt = (str) => {
    if (typeof str != "string") return false // we only process strings!
    if (str === '') return false;
    return !isNaN(+str) // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
}

// Rejection/cancellation stays a workflow signal that trumps the category
// color; a confirmed event keeps its category color (the check icon already
// marks it) — green is only the no-category fallback.
export const getBackgroundColor = (event, categoryColor = null) => {
    if (event.user_response_status === false || event.isCancelled) return  '#dc3545';
    if (categoryColor) return categoryColor;
    if (event.user_response_status === true) return 'green';
    return (parseInt(event.type) === 0 ? '#c3e6cb' : '');
}

// A color usable as TEXT on light backgrounds: returns the input when it's
// already dark enough, otherwise darkens it towards readability while
// keeping the hue.
export const getReadableTextColor = (hex) => {
    let value = (hex || '').replace('#', '');
    if (value.length === 3) value = value.split('').map(c => c + c).join('');
    if (value.length < 6) return hex;
    let r = parseInt(value.substring(0, 2), 16);
    let g = parseInt(value.substring(2, 4), 16);
    let b = parseInt(value.substring(4, 6), 16);
    const brightness = r * 0.299 + g * 0.587 + b * 0.114;
    if (brightness <= 128) return hex;
    const factor = 110 / brightness;
    const toHexPair = (n) => Math.round(n * factor).toString(16).padStart(2, '0');
    return `#${toHexPair(r)}${toHexPair(g)}${toHexPair(b)}`;
}

// Black-or-white text for an arbitrary background color (same brightness
// formula as the print-template color fields).
export const getContrastTextColor = (hex) => {
    let value = (hex || '').replace('#', '');
    if (value.length === 3) value = value.split('').map(c => c + c).join('');
    if (value.length < 6) return '#fff';
    const r = parseInt(value.substring(0, 2), 16);
    const g = parseInt(value.substring(2, 4), 16);
    const b = parseInt(value.substring(4, 6), 16);
    return (r * 0.299 + g * 0.587 + b * 0.114) > 128 ? '#212529' : '#fff';
}

export const toGreekUpperCase = (str) => {
    return str.toLocaleUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

// Load an external script once (no-op if the same src is already in the
// document). Moved from BaseMixin.
export const loadScript = (src) => {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

        document.head.appendChild(script);
    });
}

// Blank calendar-event template used by the add-event modals (home, athlete
// profile, calendar). Views copy it with Object.assign({}, ...) — was
// previously allocated globally for every component via BaseMixin data().
export const createEmptyCalendarEvent = () => ({
    formDate: null,
    formStartTime: null,
    formEndTime: null,
    formDuration: 30,
    start: null,
    end: null,
    endDate: null,
    notes: null,
    type: 1,
    title: '',
    selectedAthlete: null,
    sessionCost: 0,
    has_google_meet: false,
    categoryId: null,
    error: null,
    isSubmitting: false,
    existingClient: 1
})
